import type { TrackLikesContext } from '@amzn/bf-playback'
import type { Maybe } from '@amazon/vinyl-util'

export const LIKE_STATES = ['LIKE', 'DISLIKE', 'NEUTRAL'] as const

export type LikeState = (typeof LIKE_STATES)[number]

export function trackLikeState(track: Maybe<TrackLikesContext>): LikeState {
    if (track?.likesContext?.liked) return 'LIKE'
    return track?.likesContext?.state === 'DISLIKE' ? 'DISLIKE' : 'NEUTRAL'
}
